import type { TImage } from "../../../types";
import HeroFullWidthImage from "../hero-full-width-image/hero-full-width-image";
import HeroFullWidthVideo from "../hero-full-width-video/hero-full-width-video";
import ShapeWithColor from "../shape-with-color/shape-with-color";
import ShapeWithImage from "../shape-with-image/shape-with-image";

export type THeroShapeRendererProps = {
  shape: string;
  enableImageOverlay: boolean;
  imageDesktop?: TImage;
  imageMobile?: TImage;
  videoUrlDesktop?: string;
  videoUrlMobile?: string;
  blockIndex?: number;
  fallbackDesktopImage?: string;
};

export const HeroShapeRenderer = ({
  shape,
  enableImageOverlay,
  imageDesktop,
  imageMobile,
  videoUrlDesktop,
  videoUrlMobile,
  blockIndex,
  fallbackDesktopImage,
}: THeroShapeRendererProps) => {
  switch (shape) {
    case "no-shape": {
      if (videoUrlDesktop) {
        return (
          <HeroFullWidthVideo
            videoUrlDesktop={videoUrlDesktop}
            videoUrlMobile={videoUrlMobile}
            enableImageOverlay={enableImageOverlay}
            blockIndex={blockIndex}
          />
        );
      }

      return (
        <HeroFullWidthImage
          imageDesktop={imageDesktop}
          imageMobile={imageMobile}
          enableImageOverlay={enableImageOverlay}
          blockIndex={blockIndex}
          fallbackDesktopImage={fallbackDesktopImage}
        />
      );
    }
    case "shape-1-with-image":
    case "shape-2-with-image":
    case "shape-3-with-image": {
      return (
        <ShapeWithImage shape={shape} imageDesktop={imageDesktop} imageMobile={imageMobile} blockIndex={blockIndex} />
      );
    }
    case "shape-4-with-color":
    case "shape-5-with-color":
    case "shape-6-with-color": {
      return <ShapeWithColor shape={shape} blockIndex={blockIndex} />;
    }

    default: {
      return null;
    }
  }
};

export default HeroShapeRenderer;
